import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { btnPrimaryClass, btnSecondaryClass } from "../../../dashboardStyles";

/**
 * Back and Continue, pinned to the bottom of the screen while the page scrolls,
 * so a long step (a team with several people, a schedule opened per day) never
 * hides the way forward below the fold.
 */
const WizardActions = ({
  onPrevious,
  onContinue,
  continueLabel,
  continueIcon = "bi-arrow-right",
  hint,
  disabled = false,
}) => {
  const { t } = useTranslation();
  return (
    <div className="sticky bottom-0 z-20 flex items-center gap-3 border-t border-ink-200 bg-white/95 px-4 py-3 backdrop-blur sm:rounded-b-card sm:px-8 sm:py-4">
      {onPrevious ? (
        <button
          type="button"
          className={`${btnSecondaryClass} min-h-11`}
          onClick={onPrevious}
          disabled={disabled}
        >
          {t("Dashboard.Wizard.actions.previous")}
        </button>
      ) : (
        <span />
      )}
      {hint ? (
        <p className="m-0 hidden min-w-0 flex-1 text-center text-xs text-ink-500 md:block">
          {hint}
        </p>
      ) : (
        <span className="flex-1" />
      )}
      <button
        type="button"
        className={`${btnPrimaryClass} min-h-11 shrink-0`}
        onClick={onContinue}
        disabled={disabled}
      >
        {continueLabel ?? t("Dashboard.Wizard.actions.continue")}
        <i className={`bi ${continueIcon}`} aria-hidden="true" />
      </button>
    </div>
  );
};

WizardActions.propTypes = {
  /** Omitted on the first step, which has nothing behind it. */
  onPrevious: PropTypes.func,
  onContinue: PropTypes.func.isRequired,
  continueLabel: PropTypes.string,
  continueIcon: PropTypes.string,
  /** A line between the buttons, from `md` up. */
  hint: PropTypes.string,
  disabled: PropTypes.bool,
};

export default WizardActions;
